import React, { useState } from "react";
import ReportsTable from "../../components/ReportsTable/ReportsTable";
import "./ReportsPage.css";
import Logo from '../../assets/images/Logo.png'

// const Header = () => {
//    return (
//     <header className="header">
//       <section className="logo-section">
//        <img src={Logo} alt="Logo"/>
//       </section>
      
//       <search className="search-wrapper">
//         <input type="search" placeholder="" />
//         <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//           <circle cx="11" cy="11" r="8"></circle>
//           <path d="m21 21-4.35-4.35"></path>
//         </svg>
//       </search>
//       <div className="main-link" style={{ marginRight:'2%'}}>דוחות</div>
//     </header>
//   );
// };

const Header = ({ onSearchChange  }: { onSearchChange: (value: string) => void }) => {
  const [inputValue, setInputValue] = useState("");
  const handleChange = (value: string) => {
    setInputValue(value);
    onSearchChange(value); // מעדכן את ה-ReportsPage
  };
  return (
    <header className="header">
      <section className="logo-section">
        <img src={Logo} alt="Logo" />
      </section>

      <search className="search-wrapper">
        <input type="search" placeholder="חפש דוח..." onChange={(e) => handleChange(e.target.value)} />
        {!document.querySelector<HTMLInputElement>(".search-wrapper input")?.value && (
    <svg
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
    >
      <circle cx="11" cy="11" r="8"></circle>
      <path d="m21 21-4.35-4.35"></path>
    </svg>
  )}
      </search>

      {/* <search className="search-wrapper">
      <input 
        type="search" 
        placeholder="חפש משתמש..." 
        onChange={(e) => onSearchChange(e.target.value)} 
      />
        {!document.querySelector<HTMLInputElement>(".search-wrapper input")?.value && (
    <svg
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
    >
      <circle cx="11" cy="11" r="8"></circle>
      <path d="m21 21-4.35-4.35"></path>
    </svg>
  )}
    </search> */}
{/*
      <div className="actions">
      <span style={{fontWeight:"550"}}>חשבון לתאריך</span>
      <span style={{fontWeight:"550"}}>מ</span>
      <input type="date" className="date-input" />
      <span style={{fontWeight:"550"}}>עד</span>
      <input type="date" className="date-input" />
      <button className="btn purple">סנן תאריך</button>
      <button className="btn green">הורד לאקסל</button>
      </div>
*/}
      <div className="main-link">דוחות</div>
    </header>
  );
};

const ReportsPage: React.FC = () => {
    const [searchTerm, setSearchTerm] = useState("");
  return (
    <div className="reports-page">
      {/* <SideBar /> */}
      <div className="reports-content">
        <Header onSearchChange={setSearchTerm}/>
        <ReportsTable searchTerm={searchTerm}/>
      </div>
    </div>
  );
};

export default ReportsPage;
